import { createRoot, hydrateRoot } from "react-dom/client";
import App, { preloadRoute } from "./App.tsx";
import "./index.css";
import { installCallTracking } from "./lib/analytics";

installCallTracking();

const root = document.getElementById("root");

if (root) {
  if (root.hasChildNodes()) {
    preloadRoute(window.location.pathname)
      .catch(() => undefined)
      .then(() => hydrateRoot(root, <App />));
  } else {
    createRoot(root).render(<App />);
  }
}
